<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputRadio
        v-model="data"
        :options="relationshipPreviousStatusOptions"
        :db="db"
        :args="args"
        :skipped="skipped"
        @saveComplete="$emit('calculateRelationshipStatus')"
        @skipped="skipped=$event"
        class="radio-options-wide"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import { personalDetails } from "../../../options/personalDetails";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'RelationshipPreviousStatus',
  mixins: [personalDetails, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    statusFunction: {
      type: Function,
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'How did this previous relationship end?',
        subTitle: null,
        tip: null,
      },
      db: {
        saveLocation: 'client_client',
        saveField: 'profileRelationshipPreviousStatus',
        callbackFunction: this.statusFunction
      },
      args: {
        skippable: false,
        label: null,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
